import t from "../../i18n/i18n";
import useInitPage from "../../utils/initPage";

import Template from "../../template/template";
import UserBox from "./userBox/userBox";
import LoyalMemberBox from "./loyalMemberBox/loyalMemberBox";
import PaymentBox from "./paymentBox/paymentBox";

function RechargeLoyalMember() {
  useInitPage({ theme: { background: "loyal-bg" }, title: t("RechargeCenter.LoyalMember.Title") });

  return (
    <Template>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="chargin-warp-main">
              <div className="chargin-col-left">
                <UserBox />
                <LoyalMemberBox />
                <PaymentBox />
              </div>
              <div className="chargin-col-right">
                <div className="chargin-banner-box">
                  <a href="#">
                    <img src={t("Images.A001")} className="view-large" />
                    <img src={t("Images.A002")} className="view-small" />
                  </a>
                </div>
                <div className="chargin-banner-box">
                  <a href="#">
                    <img src={t("Images.A003")} className="view-large" />
                    <img src={t("Images.A004")} className="view-small" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Template>
  );
}

export default RechargeLoyalMember;
